import useFetchObjects from "../../api/useFetchObjects";

const useAuthoredBooks = () => {
  return useFetchObjects(
    ["authored-books"],
    "books/authored_books/",
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useAuthoredBooks;
